import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function usePaymentRequired() {
  const { data: paymentRequired = true, isLoading } = useQuery({
    queryKey: ['payment-required'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('system_settings')
        .select('value')
        .eq('key', 'payment_required')
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      if (error || !data) return false;
      return data.value === true || data.value === 'true';
    },
    staleTime: 5 * 60 * 1000,
  });

  return { paymentRequired, isLoading };
}
